export default __webpack_public_path__ + "static/image4-8d6ddeaa51bc44b8fbc5dd3413db1a84.gif";